import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Customer, CustomerState } from "src/types/customer.types";

const initialState: CustomerState = {
  list: { loading: false, data: null, error: null },
  create: { loading: false, data: null, error: null },
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    // 🧾 Fetch List
    getCustomersListRequest: (
      state,
      action: PayloadAction<{
        search?: string;
        page?: number;
        limit?: number;
      }>
    ) => {
      state.list.loading = true;
      state.list.error = null;
    },
    getCustomersListSuccess: (state, action: PayloadAction<any>) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },
    getCustomersListError: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },

    // ➕ Create Customer
    createCustomerRequest: (state, action: PayloadAction<any>) => {
      state.create.loading = true;
      state.create.error = null;
    },
    createCustomerSuccess: (state, action: PayloadAction<Customer>) => {
      state.create.loading = false;
      state.create.data = action.payload;
    },
    createCustomerError: (state, action: PayloadAction<string>) => {
      state.create.loading = false;
      state.create.error = action.payload;
    },
    resetCustomerCreate: (state) => {
      state.create = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getCustomersListRequest,
  getCustomersListSuccess,
  getCustomersListError,
  createCustomerRequest,
  createCustomerSuccess,
  createCustomerError,
  resetCustomerCreate,
} = customerSlice.actions;

export default customerSlice.reducer;
